import fork from '@haaretz/l-fork.macro';

export default function passwordValidator(password: string) {
  // istanbul ignore else
  if (!password) {
    return fork({ default: 'נא לבחור סיסמה שאיתה תתחברו לאתר', hdc: 'Enter a password' });
  }

  // istanbul ignore else
  if (typeof password !== 'string' || password.length < 6) {
    return fork({
      default: 'יש להזין סיסמה בת 6 תווים ומעלה',
      hdc: 'Please enter a password that is at least 6 characters in length',
    });
  }

  return fork({ default: 'אנא הזינו סיסמה', hdc: 'Please enter a password' });
}
